import { actionTypes } from "./booking-reasons-navigation.actions";

export interface IPetsReasonSelection{
    petId: string;
    selectedReasonCategory: string;
    selectedReasons:string[];
    additionalDescription: string;
    currentSelectionState: 0 | 1;
}

export interface IBookingReasonsNavigation {
  petsReasonSelection: IPetsReasonSelection[];
  currentNavigationIndex: number;
}

const initialState: IBookingReasonsNavigation = {
  petsReasonSelection: [],
  currentNavigationIndex: 0,

};

export const bookingReasonsNavigationReducer = (
  state: IBookingReasonsNavigation = initialState,
  action: { type: string, payload: any },
) => {
  switch (action.type) {
  case actionTypes.SET_PETS_REASON_SELECTION:
    return {
      ...state,
      petsReasonSelection: action.payload,
    };
  case actionTypes.SET_CURRENT_PET_INDEX:
    return {
      ...state,
      currentNavigationIndex: action.payload,
    };
  case actionTypes.RESET_REASONS_NAVIGATION_STORE:
    return {
      ...initialState,
    };
  default:
    return state;
  }
};
